import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';
import { EmailSnippet } from '../../../index';
import { FinalCandidateHRCvrModel } from '../../models/dashboard';
import { GoogleService } from '../google.service';
import { Node as PMNode } from 'prosemirror-model';

@Component({
  selector: 'sameta-fe-gmail-new-email',
  templateUrl: './gmail-new-email.component.html',
  styleUrls: ['./gmail-new-email.component.scss'],
  standalone: false,
})
export class GmailNewEmailComponent implements OnInit {
  @Input() candidate: FinalCandidateHRCvrModel;
  @Input() isResponse? = false;
  @Input() responseEmail?: EmailSnippet;
  @Output() emailSent: EventEmitter<EmailSnippet> = new EventEmitter();

  form: FormGroup;

  editor: Editor;
  html = '';

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  constructor(private fb: FormBuilder, private googleService: GoogleService) {
    this.editor = new Editor({});
  }

  get submitDisabled(): boolean {
    return this.form.invalid || this.isEditorEmptyTextOnly(this.editor.view.state.doc);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      to: this.fb.control(this.candidate.email, {}),
      cc: this.fb.control('', {}),
      subject: this.fb.control(this.responseEmail ? this.responseEmail.subject : 'SAMETA: Job Reaction', {}),
      body: this.fb.control('', [Validators.required]),
      threadId: this.fb.control(this.responseEmail ? this.responseEmail.threadId : null, {}),
      mailId: this.fb.control(this.responseEmail ? this.responseEmail.mailId : null, {}),
    });
  }

  sendEmail() {
    if (this.responseEmail !== undefined) {
      const subject = this.responseEmail.subject.startsWith('RE:', 0) ? this.responseEmail.subject : 'RE: ' + this.responseEmail.subject;
      this.form.get('subject').setValue(subject);
      this.form.get('threadId').setValue(this.responseEmail.threadId);
      this.form.get('mailId').setValue(this.responseEmail.mailId);
    }

    if (this.form.get('body').invalid || this.isEditorEmptyTextOnly(this.editor.view.state.doc)) {
      this.form.get('body').markAsTouched();
      this.form.get('body').updateValueAndValidity();
      return;
    }

    this.googleService.sendEmail(this.form.value).subscribe((res) => {
      this.emailSent.emit(res.body);
      this.form.get('body').setValue('');
    });
  }

  isEditorEmptyTextOnly(doc: PMNode): boolean {
    return doc.textContent.trim().length === 0;
  }
}
